import CloseIcon from '@mui/icons-material/Close';
import { AppBar, Box, CircularProgress, Dialog, DialogContent, IconButton, Toolbar, Typography } from "@mui/material";
import { lazy, Suspense, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ErrorWrapper } from "../../providers/ErrorBoundary";
import { closeDialog } from "../../redux/reducer/dialogSlice";
import { RootState } from "../../redux/store";


//ticket
const CreateTicketDialog = lazy(() => import("./ticket/EmployeeCreateTicket"));

//tax-management
const ApprovalRegimeDialog = lazy(() => import("../../pages/tax-management/manage-tax/ApprovalRegimeDialog"));
const HraStatusUpdateDialog = lazy(() => import("../../pages/tax-management/manage-tax/HraStatusUpdateDialog"));
const ViewUploadedDeductionsDocuments = lazy(() => import("../../pages/tax-management/manage-tax/DeclarationExemptionDocumentDialog"));
const RequestClarificationDialog = lazy(() => import("../../pages/tax-management/manage-tax/RequestClarificationDialog"));
const CreateReimbursementDialog = lazy(() => import("../../pages/tax-management/reimbursement/CreateReimbursementDialog"));
const CreateLTAReimbursementDialog = lazy(() => import("../../pages/tax-management/reimbursement/CreateLTAReimbursementDialog"));

const ProofSubmissionDocumentUploadDialog = lazy(() => import("../../pages/tax-management/reimbursement/ProofSubmissionDocumentUploadDialog"));
const ReimbursementAmountApprovalDialog = lazy(() => import("../../pages/tax-management/reimbursement/ReimbursementAmountApprovalDialog"));

//policy
const PolicyForm = lazy(() => import("./companyPolicy/PolicyForm"));
const PolicyDeleteDialog = lazy(() => import("./companyPolicy/DeletePolicyForm"));

//workFLow
const WorkflowMasterDialog = lazy(() => import("./workflow-master/WorkflowMasterDialog"));
const AssignEmployeeRoleDialog = lazy(() => import("./workflow-master/AssignEmployeeRoleDialog"));
const DeleteExitPolicy = lazy(() => import("./workflow-master/DeleteExitPolicy"));

//salary
const EarningComponentInactiveConfirmation = lazy(() => import("./compensation/EarningComponentInactiveConfirmationDialog"));
const DeductionStatusConfirmation = lazy(() => import("./compensation/DeductionStatusConfirmationDialog"));
const SalaryStatusConfirmation = lazy(() => import("./compensation/SalaryStatusConfirmation"));
const ClaimStatusUpdateDialog = lazy(() => import("./compensation/ClaimStatusUpdateDialog"));
const DeleteClaimDialog = lazy(() => import("./compensation/DeleteClaimDialog"));
const GenerateCompanyLevelSalaryDialog = lazy(() => import("./compensation/GenerateCompanyLevelSalaryDialog"))
const GenerateCompanyLevelReprocessSalaryDialog = lazy(() => import("./compensation/GenerateCompanyLevelReprocessSalaryDialog"))
const ViewCommentsDialog = lazy(() => import("./compensation/ViewCommentsDialog"));
const UploadSalaryExcelDocumentDialog = lazy(() => import("./compensation/UploadSalaryExcelDocumentDialog"));
const UploadSalaryIncrementExcelDocumentDialog  = lazy(() => import("./compensation/UploadSalaryIncrementExcelDocumentDialog"));
const GenerateEmployeeLevelSalaryDialog = lazy(() => import("./compensation/GenerateEmployeeLevelSalaryDialog"));
const UploadChangeSalaryStatusDialog = lazy(() => import("./compensation/UploadChangeSalaryStatusDialog"));
const CompensationTemplateFormulaDialog = lazy(() => import("./compensation/CompensationTemplateFormulaDialog"));
const CompensationRevisedSalaryBreakup = lazy(() => import("./compensation/CompensationRevisedSalaryBreakup"));

//employee
const EmployeePIPCreateForm = lazy(() => import("./employee/EmployeePIPCreateForm"));
const EmployeeConfirmationFormDialog = lazy(() => import("./employee/EmployeeConfirmationForm"));
const EmployeeApprovalConfirmationFormDialog = lazy(() => import("./employee/EmployeeApprovalConfirmationForm"));
const ResignationWithdrawalDialog = lazy(() => import("./employee/ResignationWithdrawal"));
const GenerateEmployeeRelevenaceLetter = lazy(() => import("./employee/GenerateEmployeeRelevenaceLetter"));
const EmployeeExitRequestReject = lazy(() => import("./employee/EmployeeExitRequestReject"));
const UpdateOrganizationDiagloag = lazy(() => import("./employee/OrganizationDetailsDiaglog"));
const PersonalDetailsDialog = lazy(() => import("./employee/PersonalDetailsDialog"));
const EmployeeClientBranchesMappingDialog = lazy(() => import("./employee/EmployeeClientBranchesMappingDialog"));
const ViewEmployeeBranchMappingDialoag = lazy(() => import("./employee/EmployeeBranchMappingDialog"));
const UplaodDocumentInEmployeeSection = lazy(() => import("./employee_user/DocumentUploadDialoag"));
const CreateEmployeeDialoag = lazy(() => import("./employee/CreateEmployeeDialog"));
const EmployeeExitWithdrawlConfirmationDialog = lazy(()=> import('./employee/EmployeeExitWithdrawlConfirmationDialog'))
const CancelReservedAssetsDialog = lazy(()=> import('./employee/CancelReservedAssetsDialog'))
const ChangeLastWorkingDate = lazy(() => import('./employee/ChangeLastWorkingDate')) 
const EmployeeFeedbackDetailsFormDialog = lazy(() => import("./employee/EmployeeFeedbackDetailsFormDialog"));
const EmployeeActivate = lazy(() => import('./employee/EmployeeActivateDialog')) ;
const EmployeeChangeRequestDialog = lazy(()=> import('./employee/EmployeeChangeRequestDialog'))

//user
const CreateEmployeeAddressDialog = lazy(() => import("./user/CreateEmployeeAddressDialog"));
const CreateEmployeeEducationDialog = lazy(() => import("./user/CreateEmployeeEducationDialog"));
const CreateEmployeeExperienceDialog = lazy(() => import("./user/CreateEmployeeExperienceDialog"));
const CreateAssignControlFormDialog = lazy(() => import("./user/CreateAssignControlForm"));
const DeleteAssignControlFormDialog = lazy(() => import("./user/DeleteAccessControlForm"));
const UserProfileCommonDeleteDialog = lazy(() => import("./recruitment/UserProfileCommonDeleteDialog"));
const DematAccountsForm = lazy(() => import("../../pages/user/user-profile/components/FinancialMain/DematAccountsForm"));
const InsuranceFormDiaolg = lazy(() => import("../../pages/user/user-profile/components/FinancialMain/InsuranceForm"));
const CreateEmergencyDetailsDialog = lazy(() => import("./user/EmergencyContactForm"));
const UpdateFamilyDetailsDiagloag = lazy(() => import("./employee_user/FamilyDetailsDiagloag"));
const KycDetailsUpdateDialog = lazy(() => import("./user/KycDetailsUpdateDialog"));
const BankDetailsUpdateDialog = lazy(() => import("./user/BankDetailsUpdateDialog"));
const AllocateAssetDialog = lazy(() => import("./user/AllocateAssetDialog"));
const AcknowledgeAssetsDialog = lazy(() => import("./user/AcknowledgeAssetsDialog"));
const ManageEmployeeLeaveDialog =lazy(() => import("./user/ManageEmployeeLeave"));
const ManageEmployeeTaxCycleDialog= lazy(() => import("./user/ManageEmployeeTaxCycleDialog"));

//leave
const LeaveCancelConfirmationDialog = lazy(() => import("./leave/LeaveCancelConfirmation"));
const LeaveRequestActionOnApprovalDialog = lazy(() => import("./leave/LeaveRequestActionOnApprovalDialog"));
const LeaveForm = lazy(() => import("./leave/ApplyLeaveForm"));
const CreateLeavePolicyDialog = lazy(() => import("./leave/master/CreateLeavePolicyDialog"));
const LeaveRequestActionOnApproval = lazy(() => import("./leave/LeaveRequestActionOnApprovalDialog"));
const UploadLeaveBackdatedExcelDocumentDialog  = lazy(() => import("./leave/UploadLeaveBackdatedExcelDocumentDialog"));

//Attendance
const CandidateAttendanceClock = lazy(() => import("./attendance/CandidateAttendanceClock"));
const CandidateAttendanceClockOut = lazy(() => import("./attendance/CandidateAttendanceClockOut"));
const RequestForm = lazy(() => import("./attendance/ReqularizationRequestFormDialog"));
const CancelRequestDialog = lazy(() => import("./attendance/CancelRegularizationRequestDialog"));
const AttendanceRegularizationStatusDialog = lazy(() => import("./attendance/AttendanceRegularizationStatusDialog"));
const WeekoffMasterForm = lazy(() => import("./attendance/masterDialog/WeekoffMasterFormDialog"))
const CreateAttendancePolicyDialog = lazy(() => import("./attendance/masterDialog/AttendancePolicyDiaglog").then((module) => ({ default: module.CreateAttendancePolicyDialog, })));
const AttendancePolicyDeleteDialog = lazy(() => import("./attendance/masterDialog/AttendancePolicyDiaglog").then((module) => ({ default: module.PolicyDeleteDialog, })));
const UpdateAttendancePolicyDialog = lazy(() =>import("./attendance/masterDialog/AttendancePolicyEmployeeMappingDiaglog").then((module) => ({default: module.UpdateAttendancePolicyDialog, })));
const CreateLocationDialog = lazy(() => import("./attendance/CreateLocationDialog"));
const CreateAttendanceCycleDialog = lazy(() => import("./attendance/masterDialog/CreateAttendanceCycleDialog"));
const WorkflowDialog = lazy(() => import("./attendance/CreateWorkFlowDiaglog"));
const DaywiseAttendanceSummary = lazy(() => import("./attendance/DaywiseAttendanceSummary"));
const CreateAttendanceCycleEmployeeMappingDialog = lazy(() => import("./attendance/masterDialog/CreateAttendanceCycleMappingEmployeeMappingDialog"));
const PendingApproverDialog = lazy(() => import("./attendance/RequestApproverChain"));
const UploadBackdatedExcelDocumentDialog  = lazy(() => import("./attendance/UploadBackdatedExcelDocumentDialog"));

//recruitment
const CreateCandidateDialog = lazy(() => import("./recruitment/CreateCandidateDialog"));
const CreateDepartmentDialog = lazy(() => import("./recruitment/CreateDepartmentDialog"));
const JobStatusUpdateDialog = lazy(() => import("./recruitment/JobStatusUpdateDialog"));
const InterviewStatusUpdateDialog = lazy(() => import("./recruitment/InterviewStatusUpdateDialog"));
const CreateCandidateForJobDialog = lazy(() => import("./recruitment/CreateCandidateForJobDialog"));
const JobDescription = lazy(() => import("./recruitment/JobDescription"));
const CandidateonboardDialog = lazy(() => import("./recruitment/CandidateOnboardDialog"));
const OnboardRequestUpdateDialog = lazy(() => import("./recruitment/OnboardRequestUpdateDialog"));
const CreateJobDialog = lazy(() => import("./recruitment/CreateJobDialog"));
const CreateVendorDialog = lazy(() => import("./recruitment/CreateVendorDialog"));
const CandidateOfferDialog = lazy(() => import("./recruitment/CandidateOfferDialog"));
const OfferRequestUpdateDialog = lazy(() => import("./recruitment/offerRequestUpdateDialog"));
const WithdrawOnboardRequestDialog = lazy(() => import("./recruitment/WithdrawOnboardRequestDialog"));
const OfferRequestSystemUploadDialog = lazy(() => import("./recruitment/offerRequestApproverBySystem"));
const WithdrawOnboardRequestBySystemDialog = lazy(() => import("./recruitment/WithdrawOnboardRequestBySystemDialog"));
const SendOfferConfirmationDialog = lazy(() => import("./recruitment/SendOfferConfirmationDialog"));
const SendDocumentLinkConfirmationDialog = lazy(() => import("./recruitment/SendDocumentLinkConfirmationDialog"));
const SendPreOfferDocumentLinkConfirmationDialog = lazy(() => import("./recruitment/SendPreOfferDocumentLinkConfirmationDialog"));
const SendAssessmentLinkDialog = lazy(() => import("./recruitment/SendAssessmentLinkDialog"));
const CandidateOfferSystemDetails = lazy(() => import("./recruitment/CandidateOfferDetails"));
const CandidateDocumentStatusDialog = lazy(() => import("./recruitment/CandidateDocumentStatusDialog"));
const UploadDocumentDialog = lazy(() => import("./recruitment/UploadDocumentDialog"));
const CreateEmployeeFormDialog = lazy(() => import("./recruitment/CreateEmployeeFormDialog"));
const CandidateOfferAcceptReject = lazy(() => import("./recruitment/CandidateOfferAcceptRejectDialog"));
const OfferStageFeedbackDialog = lazy(() => import("./recruitment/OfferStageFeedbackDialog"));
const BranchForm = lazy(() => import("./recruitment/BranchVertical"));
const CreateBranchLocationDialog = lazy(() => import("./recruitment/BranchLocation"));
const CreateDesignationDialog = lazy(() => import("./recruitment/CreateDesignationDialog"));
const EmpSatisfactionDialog = lazy(() => import("./employee-satisfaction/EmpSatisfactionDialog"));
const EmpSurveyFormDialog = lazy(() => import("./employee-satisfaction/EmpSurveyFormDialog"));
const DeleteSurveyDialog = lazy(() => import("./employee-satisfaction/DeleteSurveyDialog"));
const EmployeeStatusConfirmation = lazy(() => import("./employee/EmployeeStatusConfirmationDialog"));
const BackOutCandidateDialog = lazy(() => import("./recruitment/BackOutCandidate"));
const CandidateScreeningFormDialog = lazy(() => import("./recruitment/CandidateScreeningFormDialog"));
const SendOfferByDefaultOfferAcknowledgementConfirmationDialog = lazy(()=> import("./recruitment/SendOfferDefaultAcknowledge"));
const CandidateDraftConfirmationDialog = lazy(() => import("./recruitment/CandidateDraftConfirmationDialog"));
const CandidateResumeUpdateDialog = lazy(() => import("./recruitment/CandidateResumeUpdateDialog"));

//masters
const CreateClientMasterListingDialog = lazy(() => import("./masters/CreateClientMasterDialog"));
const CreateAnnouncementDialog = lazy(() => import("./masters/CreateAnnouncementDialog"));
const PreviewAnnouncementDialog = lazy(() => import("./masters/PreviewAnnouncementDialog"));

//notification-master
const NotificationMasterTemplatesDialoag = lazy(() => import("./masters/NotificationsMasterDialog"));
const ConfirmationNotificationDialog = lazy(() =>import("./notifications/ConfirmationNotification"))


//fnf create settlement
const FnfSettlementCreateDialog = lazy(() =>import("./compensation/FnfSettlementCreateDialog"));


const FnfSettlementStatusUpdateDialog =   lazy(() =>import("./compensation/FnfSettlementStatusUpdateDialog"));
const FnfEmployeeConsernConformationDialog = lazy(() =>import("./compensation/FnfEmployeeConsernConformation"));

const FnfTDSAmount = lazy(() =>import("./compensation/UpdateFnfTDSAmount"));
const Approve_Reject_FNF_TDS_Request = lazy(() =>import("./compensation/Approve_Reject_FNF_TDS"));

const Upload_CSV_FNF_Disbursement = lazy(() =>import("./compensation/Upload_CSV_FNF_Disbursement"));

const FnfSendForApprovalDialog = lazy(()=> import("./compensation/FnfSendForApprovalDialog"));

//anouncement

const UserAnnouncementDialog = lazy(()=> import("./announcement/UserAnnouncementDialog"));
const AnnouncementStatusUpdateDialog = lazy(()=> import("./masters/AnnouncementStatusUpdateDialog"))
const createEmployeeBackdatedAttendanceByAdminDialoag = lazy(()=> import("./employee/CreateEmployeeBackdatedAttendanceByAdminDialog"))
const createEmployeeBackdatedLeaveByAdminDialoag = lazy(()=> import("./employee/CreateEmployeeBackdatedLeaveByAdminDialoag"))


//fnf 
const Upload_CSV_FNF_Varification = lazy(() => import("./fnf/Upload_CSV_FNF_Settlment_Varification"));
const Approve_Reject_FNF_Recovery_payment_Varification = lazy(() => import("./fnf/Approve_Reject_FNF_Recovery_payment_VarificationDialog"));




const CommonDialogComponent = () => {
    const dispatch = useDispatch();
    const { isOpen, type, isFullScreen, title } = useSelector((state: RootState) => state.dialog);

    const handleClose = useCallback(() => {
        dispatch(closeDialog());
    }, [dispatch]);


    const mediumDialogTypes = ['candidateOnboardForm', 'editCandidateOnboardForm', 'updateOnboardRequestForm', "workflowMasterCreate", "createAttendancePolicy",
        'createWeekoffMaster', 'attendanceCycleCreateForm', 'attendanceCycleEditForm', 'candidateOfferDetails', "editCompanyPolicy", "createCompanyPolicy", "createInsuranceDetails","FnfSendForApproval",
        "createDematDetails", "updateOrganizationDetails", "createBranchLocation", "employeeClientBranches" , "attendanceCycleMappingEditForm" , "uploadDeductionsDocument", "notificationConfirmation"
        ,"createSettlementForm", "candidatebackout", "createAnnouncement", "candidateScreeningForm","candidateOfferAcceptReject", "candidateDraftConfirmation", "updateCandidateResume"];

        const largeDialogTypes = ["UserAnnouncementDialog","employeeChangeRequest"]

    const disableOutSideClickCloseDialog = ['createLTAReimbursement']
    // Map dialog types to their respective components
    const dialogComponentMap: Record<string, React.LazyExoticComponent<any> | React.FC<any>> = {

        //Ticket
        createTicket: CreateTicketDialog,

        //Tax-Management
        regimeConfirmation: ApprovalRegimeDialog,
        hraStatusUpdate: HraStatusUpdateDialog,
        uploadDeductionsDocument : ViewUploadedDeductionsDocuments,  
        requestClarification :RequestClarificationDialog,
        createReimbursement :CreateReimbursementDialog,
        createLTAReimbursement :CreateLTAReimbursementDialog,
        proofSubmissionDocumentUpload: ProofSubmissionDocumentUploadDialog,
        reimbursementAmountApprovalDialog: ReimbursementAmountApprovalDialog,

        //Policy
        editCompanyPolicy: PolicyForm,
        createCompanyPolicy: PolicyForm,
        deleteCompanyPolicy: PolicyDeleteDialog,

        //workFlowMaster
        workflowMasterCreate: WorkflowMasterDialog,
        EditWorkFlowMaster: WorkflowMasterDialog,
        EmployeeRoleAssignmentDialog: AssignEmployeeRoleDialog,
        DeleteExitPolicydata: DeleteExitPolicy,

        //salary
        EarningComponentInactiveConfirmation: EarningComponentInactiveConfirmation,
        DeductionStatusConfirmation: DeductionStatusConfirmation,
        SalaryStatusConfirmation: SalaryStatusConfirmation,
        claimStatusUpdate: ClaimStatusUpdateDialog,
        deleteClaim: DeleteClaimDialog,
        CompensationTemplateFormulaDialog: CompensationTemplateFormulaDialog,
        generateCompanyLevelSalaryDialog: GenerateCompanyLevelSalaryDialog,
        generateCompanyLevelReprocessSalaryDialog: GenerateCompanyLevelReprocessSalaryDialog,
        viewRemarkDialog: ViewCommentsDialog,
        uploadSalaryExcelDocumentDialog: UploadSalaryExcelDocumentDialog,
        uploadSalaryIncrementExcelDocumentDialog: UploadSalaryIncrementExcelDocumentDialog,
        generateEmployeeLevelSalaryDialog: GenerateEmployeeLevelSalaryDialog,
        uploadChangeSalaryStatusDialog: UploadChangeSalaryStatusDialog,
        revisedSalaryBreakUpDialog: CompensationRevisedSalaryBreakup,


        //Employee
        employeePIPCreateForm: EmployeePIPCreateForm,
        employeePIPViewForm: EmployeePIPCreateForm,
        employeeConfirmation: EmployeeConfirmationFormDialog,
        employeeApprovalConfirmation: EmployeeApprovalConfirmationFormDialog,
        ResignationWithdrawalDialog: ResignationWithdrawalDialog,
        EmployeeExitRequestReject: EmployeeExitRequestReject,
        DownloadRelevanceLetter: GenerateEmployeeRelevenaceLetter,
        updateOrganizationDetails: UpdateOrganizationDiagloag,
        updatePersonalDetails: PersonalDetailsDialog,
        employeeClientBranches: EmployeeClientBranchesMappingDialog,
        viewEmployeeBranchMapping:ViewEmployeeBranchMappingDialoag,
        uploadDocumentInEmployeeSection:UplaodDocumentInEmployeeSection,
        createEmployee:CreateEmployeeDialoag,
        EmployeeStatusConfirmation: EmployeeStatusConfirmation,
        employeeActivate:EmployeeActivate,
        ChangeLastWorkingDate: ChangeLastWorkingDate,
        EmployeeExitWithdrawlConfirmation: EmployeeExitWithdrawlConfirmationDialog,
        cancelReservedAssets: CancelReservedAssetsDialog,
        
        employeeFeedbackDetails: EmployeeFeedbackDetailsFormDialog,
        employeeChangeRequest : EmployeeChangeRequestDialog,
        createEmployeeEducation: CreateEmployeeEducationDialog,

        //User
        createEmployeeAddress: CreateEmployeeAddressDialog,
        createEmployeeExperience: CreateEmployeeExperienceDialog,
        userProfileCommonDeleteDialog: UserProfileCommonDeleteDialog,
        createContactDetails: CreateEmergencyDetailsDialog,
        createInsuranceDetails: InsuranceFormDiaolg,
        createDematDetails: DematAccountsForm,
        updateFamilyDetails: UpdateFamilyDetailsDiagloag,
        assignAccessControl: CreateAssignControlFormDialog,
        deleteAccessControl: DeleteAssignControlFormDialog,
        kycDetailsUpdateDialog : KycDetailsUpdateDialog,
        bankDetailsUpdateDialog : BankDetailsUpdateDialog,
        allocateAssest : AllocateAssetDialog,
        acknowledgeAsset : AcknowledgeAssetsDialog,
        ManageEmployeeLeave : ManageEmployeeLeaveDialog,
        manageEmployeeTaxCycleDialog: ManageEmployeeTaxCycleDialog,

        //Leave
        deleteLeaveRequest: LeaveCancelConfirmationDialog,
        LeaveRequestActionOnApprovalDialog: LeaveRequestActionOnApprovalDialog,
        leavePolicyCreateForm: CreateLeavePolicyDialog,
        leavePolicyEditForm: CreateLeavePolicyDialog,
        LeaveRequestActionOnApproval: LeaveRequestActionOnApproval,
        LeaveRequestForm: LeaveForm,
        uploadLeaveBackdatedExcelDocument: UploadLeaveBackdatedExcelDocumentDialog,


        //Attendance
        ClockConfirmation: CandidateAttendanceClock,
        ClockOutConfirmation: CandidateAttendanceClockOut,
        ReqularzationRequestForm: RequestForm,
        uploadBackdatedExcelDocument:UploadBackdatedExcelDocumentDialog,
        // createDepartment:  PolicyFormDialog ,                                //check refrence
        deleteAttendancePolicy: AttendancePolicyDeleteDialog,
        createAttendancePolicy: CreateAttendancePolicyDialog,
        updateAttendancePolicy: UpdateAttendancePolicyDialog,
        CancelRegularizationRequestDialog: CancelRequestDialog,
        AttendanceRegularizationStatusDialog: AttendanceRegularizationStatusDialog,
        create_attendance_Workflow: WorkflowDialog,
        edit_attendance_Workflow: WorkflowDialog,
        createWeekoffMaster: WeekoffMasterForm,
        locationCreateForm: CreateLocationDialog,
        locationEditForm: CreateLocationDialog,
        locationDelete: CreateLocationDialog,
        attendanceCycleCreateForm: CreateAttendanceCycleDialog,
        attendanceCycleEditForm: CreateAttendanceCycleDialog,
        attendanceCycleMappingEditForm: CreateAttendanceCycleEmployeeMappingDialog,
        attendanceCycleDeleteForm: CreateAttendanceCycleDialog,
        dayWiseAttendanceSummary: DaywiseAttendanceSummary,
        requestApprover:PendingApproverDialog,

        //recruitment
        createDepartment: CreateDepartmentDialog,
        editDepartment: CreateDepartmentDialog,
        createDesignation: CreateDesignationDialog,
        editDesignation: CreateDesignationDialog,
        jobStatusUpdate: JobStatusUpdateDialog,
        interviewStatusUpdate: InterviewStatusUpdateDialog,
        createCandidateForJob: CreateCandidateForJobDialog,
        showJobDescription: JobDescription,
        assignVendor: CreateVendorDialog,
        updateOnboardRequestForm: OnboardRequestUpdateDialog,
        updateofferRequestForm: OfferRequestUpdateDialog,
        withdraofferRequestForm: WithdrawOnboardRequestDialog,
        candidateOfferDetails: CandidateOfferSystemDetails,
        updateofferRequestBySystemForm: OfferRequestSystemUploadDialog,
        withdrawOfferRequestBySystemForm: WithdrawOnboardRequestBySystemDialog,
        SendOfferDialog: SendOfferConfirmationDialog,
        sendDocumentLinkDialog: SendDocumentLinkConfirmationDialog,
        sendPreOfferDocumentLinkDialog: SendPreOfferDocumentLinkConfirmationDialog,
        sendAssessmentLinkDialog: SendAssessmentLinkDialog,
        sendReminderAssessmentLinkDialog: SendAssessmentLinkDialog,

        candidateOfferAcceptReject: CandidateOfferAcceptReject,
        candidateDocumentStatus: CandidateDocumentStatusDialog,
        uploadDocumentDialog: UploadDocumentDialog,
        offerStageFeedbackUpdate: OfferStageFeedbackDialog,
        createBranchLocation: CreateBranchLocationDialog,
        branchlocationUpdateForm: CreateBranchLocationDialog,
        mapbranchverticalmapping: BranchForm,
        createJob: CreateJobDialog,
        cloneJob: CreateJobDialog,
        editJob: CreateJobDialog,
        createCandidate: CreateCandidateDialog,
        candidateOnboardForm: CandidateonboardDialog,
        editCandidateOnboardForm: CandidateonboardDialog,
        candidateOfferForm: CandidateOfferDialog,
        candidateOfferUpdateForm: CandidateOfferDialog,
        createEmployeeForm: CreateEmployeeFormDialog,
        candidatebackout: BackOutCandidateDialog,
        candidateScreeningForm: CandidateScreeningFormDialog,
        SendOfferByDefaultOfferAcknowledgementConfirmationDialog : SendOfferByDefaultOfferAcknowledgementConfirmationDialog,
        candidateDraftConfirmation: CandidateDraftConfirmationDialog,
        updateCandidateResume: CandidateResumeUpdateDialog,

        //Masters
        clientMasterDialog: CreateClientMasterListingDialog,
        createAnnouncement :CreateAnnouncementDialog,
        previewAnnouncement: PreviewAnnouncementDialog,

        //employee satisfaction
        empsatisfactionDialog: EmpSatisfactionDialog,
        empSurveyFormDialog: EmpSurveyFormDialog,
        deleteSurveyDialog : DeleteSurveyDialog,

        //notifaction-masters
        notificationMasterTemplatesDialoag: NotificationMasterTemplatesDialoag,
        notificationConfirmation: ConfirmationNotificationDialog,
        createSettlementForm: FnfSettlementCreateDialog,

        FnfSettlementStatusUpdateDialog: FnfSettlementStatusUpdateDialog,

        FnfEmployeeConsernConformation : FnfEmployeeConsernConformationDialog,
        updateTDSAmount :FnfTDSAmount,
        approve_Reject_FNF_TDS:Approve_Reject_FNF_TDS_Request,
        Upload_CSV_FNF_Disbursement:Upload_CSV_FNF_Disbursement,
        FnfSendForApproval : FnfSendForApprovalDialog,
         
        //announcement
        UserAnnouncementDialog: UserAnnouncementDialog,
        AnnouncementStatusUpdateDialog: AnnouncementStatusUpdateDialog,
        createEmployeeBackdatedAttendanceByAdmin: createEmployeeBackdatedAttendanceByAdminDialoag,
        createEmployeeBackdatedLeaveByAdmin: createEmployeeBackdatedLeaveByAdminDialoag,

        //fnf 
        Upload_CSV_FNF_Varification: Upload_CSV_FNF_Varification,

        approve_Reject_FNF_Recovery_payment_Varification: Approve_Reject_FNF_Recovery_payment_Varification,

        // employeeChangeRequest: EmployeeChangeRequestDialog,
    };



    // Define extra props for specific dialog types
    const dialogPropsMap: Record<string, object> = {
        workflowMasterCreate: { pageType: "create" },
        EditWorkFlowMaster: { pageType: "edit" },
    };


    // Get the selected component
    const SelectedDialogComponent = type ? dialogComponentMap[type] : null;

    // Get extra props if available
    const extraProps = type && dialogPropsMap[type] ? dialogPropsMap[type] : {};


    return (
        <Dialog open={isOpen} fullScreen={isFullScreen}   onClose={(event, reason) => {
           if(disableOutSideClickCloseDialog.includes(type)){
            if (reason !== "backdropClick") {
                handleClose();
              }
           }else{
            handleClose();

          }
          }} fullWidth={true} maxWidth={mediumDialogTypes?.includes(type) ? 'md' :largeDialogTypes?.includes(type) ? 'lg' : 'sm'}>
            {isFullScreen && <AppBar elevation={7} sx={{ position: 'relative' }}>
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={handleClose}> <CloseIcon /> </IconButton>
                    <Typography sx={{ ml: 2, flex: 1 }} variant="h5" fontWeight={"h4.fontWeight"} component="div">{title}</Typography>
                </Toolbar>
            </AppBar>}
            <Suspense fallback={<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' , minHeight:'15vh'}}>
                <CircularProgress />
            </Box>}>
            <ErrorWrapper>
                {isFullScreen ? (
                    <DialogContent sx={{ height: "100%" }}>
                        {SelectedDialogComponent && <SelectedDialogComponent handleClose={handleClose}  {...extraProps} />}
                    </DialogContent>
                ) : (
                    SelectedDialogComponent && <SelectedDialogComponent handleClose={handleClose} {...extraProps} />
                )}
                </ErrorWrapper>
            </Suspense>
        </Dialog>
    )
}
export default CommonDialogComponent;